import ApplicationController from './application_controller';

/**
 * Turbo-visits the changed radio's data-url.
 *
 * Usage:
 *   <form data-controller="radio-navigate">
 *     <input type="radio" data-url="/some/path" data-action="change->radio-navigate#navigate">
 *   </form>
 *
 * Element-scoped replacement for inline body scripts that bound change
 * listeners directly to radios: Turbo Drive does not re-execute those
 * scripts on cache restoration visits (back/forward), which left restored
 * radios with no handler.
 */
export default class extends ApplicationController {
  navigate(event) {
    const { url } = event.target.dataset;
    if (url) {
      Turbo.visit(url);
    }
  }
}
